export default {
  TitleFormName: 'Tìm kiếm chứng từ',
  EventName: {
    ViewVoucher: 'Xem chứng từ',
    ExportExcel: 'Xuất Excel',
    AddFilterItem: 'Thêm điều kiện',
    Search: 'Tìm kiếm',
    Delete: 'Xóa',
    Print: 'In',
    Cancel: 'Hủy',
  },
  ScreenText: {
    DatePeriod: 'Thời gian',
    VoucherPosted: 'Chứng từ đã ghi sổ',
    VoucherNoPost: 'Chứng từ chưa ghi sổ',
    AllVoucher: 'Tất cả chứng từ',
    GroupByVoucher: 'Nhóm theo chứng từ',
    Search: 'Tìm theo',
    Condition: 'Điều kiện',
    FromDate: 'Từ ngày',
    ToDate: 'Đến ngày',
    FromValue: 'Từ giá trị',
    ToValue: 'Đến giá trị',
    Value: 'Giá trị',
    Title: 'Tìm chứng từ',
    PrintTitle: 'Chọn cột cần in',
    WarningContent: 'Bạn hãy chọn chứng từ cần xem chi tiết.',
    WarningTitle: 'Cảnh báo',
  },
  Print: {
    TitleContent: 'Tiêu đề',
    AdjustColumnTitle: 'Điều chỉnh kích thước cột',
    AdjustAll: 'Điều chỉnh tất cả các cột',
    AdjustFinal: 'Điều chỉnh cột cuối cùng',
    NoAdjust: 'Không điều chỉnh',
  },
};
